import { RouterProvider } from 'react-router-dom';
import { router } from './routers';
import { QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { createQueryClient } from './config/queryClient';
import { ToastProvider } from './common/toast/ToastProvider';
import { lazy, FC, Suspense, useMemo } from 'react';

const LazyReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools').then(module => ({
    default: module.ReactQueryDevtools,
  })),
);

export const App: FC = () => {
  const queryClient = useMemo(() => createQueryClient(), []);

  return (
    <QueryClientProvider client={queryClient}>
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <LazyReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
};
